module.exports = __webpack_public_path__ + "static/media/return.69bd110e.svg";